import 'bootstrap/dist/css/bootstrap.min.css'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState, useRef } from 'react'
import axios from 'axios'

function App() {
  const navigate = useNavigate()
  const [cityFilter, setCityFilter] = useState(null)//città filtrate ad ogni change dell'input 'città'
  const [città, setCittà] = useState([])//città trovate in MYSQL con axios 
  const [eventi, setEventi] = useState({})
  const [formData, setFormData] = useState({//DATI DAGLI INPUT UTENTE
    città: null, tipologia: null
  })
  const [msgCity, setMsgCity] = useState(null)
  const [msgTipologia, setMsgTipologia] = useState(null)
  const cityFilterId = useRef()//per display 'block' o 'none' del div delle città selezionabili
  const cittàValue = useRef()//per modificare il value nell'input 'città'

  function handleChangeCittà(e) {//RICERCA PER CITTA'
    const { value } = e.target
    setFormData({ città: value }); setMsgCity(null); setMsgTipologia(null)
    let filter = []; setCityFilter(null)
    città.some((elem, index) => {//filtraggio città da input 'città'
      if (value.toLowerCase() !== '') {
        // let result = elem.substring(0, value.length)//result è l'elemento [città] mozzato, con length uguale a value.length'
        if (elem.toLowerCase().includes(value.toLowerCase()) === true) {//match tra input 'città' e array città
          filter.push(elem.toLowerCase())
        }
      }
    })
    if (filter.length > 0) {//se in input 'città' viene trovata una città in array 'citta'
      filter = filter.filter((value, index) => filter.indexOf(value) === index)//tolgo le città ripetute
      setCityFilter(filter)
      cityFilterId.current.style.display = 'block'
    } else { cityFilterId.current.style.display = "none" }
  }
  const cittàCliccata = async (elem) => {//RICERCA PER CITTA' CLICCATA DA BANNER CITTA' TROVATE
    cittàValue.current.value = elem
    setFormData({ ...formData, città: elem })
    try {//update in MYSQL della città cliccata per analytics
      if (localStorage.getItem('email') !== 'maladmin@admin.it') {
        const res = await axios.get(`/cercaPerCitta/${elem}`)
      }
    } catch (err) { console.log(err) }

    const evt = eventi.filter(item =>
      (item.città.toUpperCase().includes(elem.toUpperCase()) === true ||
        item.comune.toUpperCase().includes(elem.toUpperCase()) === true ||
        item.regione.toUpperCase().includes(elem.toUpperCase()) === true) &&
      (item.accettazione === 'true' ||
        item.accettazione === 'null'))
    if (evt.length === 0) { setMsgCity(`Nessun evento trovato a ${elem}`); return }
    navigate('/viewEventi', {
      replace: true,
      state: { evento: evt, comune: elem }
    })
  }
  async function handleChangeSelect(e) {//RICERCA PER TIPOLOGIA
    const { value, type, checked } = e.target//attributi degli input
    const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
    try {//insert in MYSQL della tipologia scelta per analytics
      if (localStorage.getItem('email') !== 'maladmin@admin.it') {
        const res = await axios.get(`/cercaPerTipologia/${inputValue}`)
      }
    } catch (err) { console.log(err) }
    setMsgCity(null); setMsgTipologia(null); setFormData({ tipologia: inputValue })
    cittàValue.current.value = ''
    const filtro = eventi.filter(item => item.tipologia === inputValue)
    const filtro1 = filtro.filter(item => item.accettazione !== 'false')
    const filtro2 = filtro1.filter(item => item.accettazione !== 'rejection')
    if (filtro2.length === 0) { setMsgTipologia(`Nessun evento trovato per ${inputValue}`); return }
    navigate('/viewEventi', {
      replace: true,
      state: { evento: filtro2, status: 'fromSelect' }
    })
  }
  async function handleSubmit(e) {//RICERCA PER CITTA' INSERITA DA INPUT 
    e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
    try {//insert in MYSQL della città inserita con il CERCA
      if (localStorage.getItem('email') !== 'maladmin@admin.it') {
        if (formData.città) {
          const res = await axios.get(`/cercaPerCitta/${formData.città}`)
        }
      }
    } catch (err) { console.log(err) }
    cittàValue.current.value = formData.città
    if (!formData.città) { setMsgCity('Campo obbligatorio'); return }
    const evt = eventi.filter(item =>
      (item.città.toUpperCase().trim() === formData.città.toUpperCase().trim() ||
        item.comune.toUpperCase().trim() === formData.città.toUpperCase().trim() ||
        item.regione.toUpperCase().trim() === formData.città.toUpperCase().trim()) &&
      (item.accettazione === 'true' ||
        item.accettazione === 'null'))
    if (evt.length === 0) { setMsgCity(`Nessun evento trovato a ${formData.città}`); return }
    navigate('/viewEventi', {
      replace: true,
      state: { evento: evt, comune: formData.città }
    })
  }

  useEffect(() => {//caricamento delle città da server nodejs (MYSQL)
    let arr = []
    axios.get('/getEventi/dataFine').then(res => {
      setEventi(res.data)
      const response = res.data
      response.forEach(element => {//carico 'setCittà' con le città presenti in MYSQL
        arr.push(element.città, element.comune, element.regione)
      })
      setCittà(arr)
    })
    //--------------- cancella div delle città trovate con click sul body ---------------
    cittàValue.current.addEventListener('change', () => {
      document.addEventListener('mouseup', onMouseUp)
      function onMouseUp() {//gestione input 'cittàValue' al click nel body del documento 
        if (cittàValue !== '') cittàValue.current.value = ''
        if (cityFilterId.current.style.display === "block") {
          cityFilterId.current.style.display = "none"
          document.removeEventListener('mouseup', onMouseUp)
        }
      }
    })
  }, [])

  // useEffect(() => { console.log('città:', città) }, [città])

  return (<>
    <div className='container mt-4' style={{ backgroundColor: 'whitesmoke' }}>
      <hr />
      <div>
        <h3 style={{ textAlign: 'center' }}>TROVA UN EVENTO</h3>
        <form onSubmit={handleSubmit}>
          {/* ---------------------- CERCA CON CHIAVE TIPO EVENTO -------------------- */}
          <div className="input-group mb-3">
            <span className="input-group-text" id="basic-addon1"
              style={{ color: 'navy', fontWeight: '600', border: '1px solid grey' }}>
              Tipo d'evento
            </span>
            <select className="form-select" aria-label="Default select example"
              style={{ display: 'inline', marginRight: '5%', border: '1px solid grey' }}
              name="tipologia"
              onChange={handleChangeSelect}>
              <option></option>
              <option value="Auto raduno">Auto raduno</option>
              <option value="Benessere olistico">Benessere olistico</option>
              <option value="Carnevale">Carnevale</option>
              <option value="Concerto">Concerto</option>
              <option value="Concorso">Concorso</option>
              <option value="Cultura">Cultura</option>
              <option value="Enogastronomico">Enogastronomico</option>
              <option value="Evento ludico">Evento ludico</option>
              <option value="Fashion">Fashion</option>
              <option value="Festa del patrono">Festa del patrono</option>
              <option value="Festa a tema">Festa a tema</option>
              <option value="Festival">Festival</option>
              <option value="Fiera">Fiera</option>
              <option value="Halloween">Halloween</option>
              <option value="Luna park">Luna park</option>
              <option value="Meeting">Meeting</option>
              <option value="Mercatino">Mercatino</option>
              <option value="Mercatino natalizio">Mercatino natalizio</option>
              <option value="Moto raduno">Moto raduno</option>
              <option value="Mostra">Mostra</option>
              <option value="Mostra-mercato-fiori">Mostra-mercato-fiori</option>
              <option value="Natale">Natale</option>
              <option value="Notte bianca">Notte bianca</option>
              <option value="Presepe">Presepe</option>
              <option value="Sagra">Sagra</option>
              <option value="Spettacolo di magia">Spettacolo di magia</option>
              <option value="Spettacolo teatrale">Spettacolo teatrale</option>
              <option value="Sportivo">Sportivo</option>
              <option value="Altro">Altro</option>
            </select>
          </div>
          {msgTipologia && <p style={{ color: 'red' }}><i>{msgTipologia}</i></p>}

          {/* ---------------- CERCA CON CHIAVE CITTA' ------------------- */}
          <div className="input-group mb-1">
            <span className="input-group-text" id="basic-addon1"
              style={{ color: 'navy', fontWeight: '600', border: '1px solid grey' }}>
              Città/Regione
            </span>
            <input className='form-control' aria-label="Città" aria-describedby="basic-addon1"
              style={{ display: 'inline', border: '1px solid grey' }}
              type='text'
              placeholder='Es. Lazio'
              onChange={handleChangeCittà}
              ref={cittàValue}
            />
            <button type='submit'
              style={{ fontSize: 'small', marginRight: '5%', border: '1px solid grey' }}>
              <b><i>Cerca</i></b>
            </button>
          </div>
          {msgCity && <p style={{ color: 'red' }}><i>{msgCity}</i></p>}

          {/* ----------------- BANNER CITTA' TROVATE -------------------- */}
          <div ref={cityFilterId} style={{
            border: '1px solid black', zIndex: '1',
            padding: '5px',
            position: 'absolute',
            left: '6%',
            width: '14rem',
            display: 'none',
            backgroundColor: 'whitesmoke'
          }}>
            {cityFilter &&
              cityFilter.map((elem, index) => (
                <div className='filterCity' key={index}>
                  <p style={{ cursor: 'pointer', fontSize: 'medium', margin: '-6px 0' }} onClick={() => { cittàCliccata(elem) }}>{elem}
                  </p>
                  {cityFilter.length !== index + 1 && <hr />}
                </div>
              ))}
          </div>
        </form>
      </div><hr />

    </div>
    {/* 
    <div style={{ textAlign: 'center', position: 'relative', top: '2em'}}>
       <img src={"https://leuro-bucket.s3.amazonaws.com/carnevale.jpg"} style={{width: '40%'}} alt=""/> */}
    {/* <div style={{ left: '0', right: '0', bottom: '20px', margin: 'auto', position: 'absolute' }}> */}
    {/* <span className='btn' style={{ backgroundColor: 'darkblue', color: 'white', border: '2px solid gold' }} onClick={() => {
          const filtro = eventi.filter(item => { return (item.tipologia === 'Natale' || item.tipologia === 'Mercatino natalizio' || item.tipologia === 'Mercatino') })
          const filtro1 = filtro.filter(item => item.accettazione !== 'false')
          const filtro2 = filtro1.filter(item => item.accettazione !== 'rejection')
          navigate('/viewEventi', {
            replace: true,
            state: { evento: filtro2, status: 'fromSelect' }
          })
        }}>✨ MERCATINI ✨
        </span>

        <span className='btn' style={{ marginLeft: '1em', backgroundColor: 'seagreen', color: 'white', border: '2px solid gold' }} onClick={() => {
          const filtro = eventi.filter(item => { return (item.tipologia === 'Presepe' || item.tipologia === 'Natale') })
          const filtro1 = filtro.filter(item => item.accettazione !== 'false')
          const filtro2 = filtro1.filter(item => item.accettazione !== 'rejection')
          navigate('/viewEventi', {
            replace: true,
            state: { evento: filtro2, status: 'fromSelect' }
          })
        }}>
          🎄 PRESEPI 🎄
        </span> */}
    {/* </div> */}
    {/* </div> */}
  </>
  )
}

export default App